// mutations
const PAPELERIA_ENLISTMENT_ALL = (state, papeleriaEnlistment) => {
  if (papeleriaEnlistment.code === 1) {
    state.papeleriaEnlistment = papeleriaEnlistment.data
    state.status = 'success'
  } else {
    alert(papeleriaEnlistment.message)
    state.status = 'error'
  }
}

const PAPELERIA_ENLISTMENT_FORM = (state, papeleriaEnlistment) => {
  if (papeleriaEnlistment.code === 1) {
    state.papeleriaEnlistment = papeleriaEnlistment.data
    state.status = 'success'
  } else {
    alert(papeleriaEnlistment.message)
    state.status = 'error'
  }
}

const PAPELERIA_ENLISTMENT_SHOW = (state, papeleriaEnlistment) => {
  if (papeleriaEnlistment.code === 1) {
    state.papeleriaEnlistment = papeleriaEnlistment.data
    state.status = 'success'
  } else {
    alert(papeleriaEnlistment.message)
    state.status = 'error'
  }
}

const PAPELERIA_ENLISTMENT_CREATE = (state, papeleriaEnlistment) => {
  if (papeleriaEnlistment.code === 1) {
    state.papeleriaEnlistment = papeleriaEnlistment.data
    state.status = 'success'
    alert(papeleriaEnlistment.message)
  } else {
    alert(papeleriaEnlistment.message)
    state.status = 'error'
  }
}

const PAPELERIA_ENLISTMENT_UPDATE = (state, papeleriaEnlistment) => {
  if (papeleriaEnlistment.code === 1) {
    state.papeleriaEnlistment = papeleriaEnlistment.data
    state.status = 'success'
    alert(papeleriaEnlistment.message)
  } else {
    alert(papeleriaEnlistment.message)
    state.status = 'error'
  }
}

const PAPELERIA_ENLISTMENT_DELETE = (state, papeleriaEnlistment) => {
  if (papeleriaEnlistment.code === 1) {
    state.papeleriaEnlistment = papeleriaEnlistment.data
    state.status = 'success'
    alert(papeleriaEnlistment.message)
  } else {
    alert(papeleriaEnlistment.message)
    state.status = 'error'
  }
}

export default {
  PAPELERIA_ENLISTMENT_ALL,
  PAPELERIA_ENLISTMENT_FORM,
  PAPELERIA_ENLISTMENT_SHOW,
  PAPELERIA_ENLISTMENT_CREATE,
  PAPELERIA_ENLISTMENT_UPDATE,
  PAPELERIA_ENLISTMENT_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/enlistment/mutations.js